var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.lightboxOpen)?_c('lightbox',{attrs:{"album":_vm.photoAlbums[_vm.albumIndex].images,"startingIndex":_vm.imageIndex},on:{"closeLightbox":function($event){_vm.lightboxOpen = false}}}):_vm._e(),_vm._v(" "),_vm._l((_vm.photoAlbums),function(album,index){return _c('photo-album',{key:album.title.en,attrs:{"album":album,"albumIndex":index},on:{"open-lightbox":_vm.openLightbox}})})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-777b69a2","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Photos.vue
// module id = 258
// module chunks = 0